require('./brokerInterveniersInvestment.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @libs
const get = require('lodash/object/get');

const { TYPE_FUNDS, CHARGE_ACCOUNT_PREFIX } = require('constants/index');

class BrokerInterveniersInvestment extends React.Component {
    buildAssociatedAccount() {
        const { contentInfo } = this.props;
        const associateAccount = contentInfo.associateAccount;
        const balance = associateAccount.balance;
        const plainAmountObject = getPlainAmountObject(balance);

        return (
            <div className="broker-interveniers-investment__associated-account">
                <h5 className="broker-interveniers-investment__subtitle">
                    {formatText('broker-intervenersInvestmentAssocAccount')}
                </h5>
                <p>
                    <strong>{get(associateAccount, 'ibanComplex.codbban')}</strong>
                    <br />
                    ({formatText('broker-intervenersInvestmentAssocAccountBalance')} :{' '}
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                </p>
            </div>
        );
    }

    buildHolder() {
        const { contentInfo } = this.props;
        return (
            <div className="broker-interveniers-investment__holder">
                <h5 className="broker-interveniers-investment__subtitle">
                    {formatText('broker-intervenersInvestmentFirstTitular')}
                </h5>
                <p>
                    <strong>{contentInfo.owner}</strong>
                    <br />
                    ({formatText('broker-interveniersInterventionType')}:{' '}
                    {formatText(`interventionTypes-${contentInfo.intervenerType.trim()}`)})
                </p>
            </div>
        );
    }

    buildRent() {
        const { contentInfo } = this.props;
        const contractNumberLong = CHARGE_ACCOUNT_PREFIX + contentInfo.contractValues.getIn(['contrato', 'producto']) + contentInfo.contractValues.getIn(['contrato', 'numerodecontrato']);
        let name;
        if (contentInfo.type === TYPE_FUNDS) {
            name = contentInfo.contractValues.get('descripcion');
        } else {
            name = formatText('broker-intervenersInvestmentSubTitle', [contentInfo.name]);
        }

        return (
            <div className="broker-interveniers-investment__rent">
                <h4 className="broker-interveniers-investment__title">{name}</h4>
                <p>{formatText('broker-intervenersInvestmentNContract')}: {contractNumberLong}</p>
            </div>
        );
    }

    buildTitle() {
        const { contentInfo } = this.props;
        let title;
        if (contentInfo.type === TYPE_FUNDS) {
            title = formatText('broker-interveniersInvestmentFund')
        } else {
            title = formatText('broker-interveniersInvestmentValue')
        }
        return title;
    }

    render() {
        const title = this.buildTitle();
        return (
            <ContentBox
                id="BrokerInterveniersInvestment"
                customClassName="broker-interveniers-investment"
                title={title}
            >
                {this.buildRent()}
                {this.buildHolder()}
                {this.buildAssociatedAccount()}
            </ContentBox>
        );
    }
}

BrokerInterveniersInvestment.propTypes = {
    contentInfo: PropTypes.object.isRequired
};

module.exports = BrokerInterveniersInvestment;
